module.exports = __webpack_public_path__ + "img/mobilesf.049ec61c.png";